import { POWER_COLOR } from './constants';
import type { Particle, PowerUpId } from './types';

export function burst(x: number, y: number, color: string, n = 14): Particle[] {
  const out: Particle[] = [];
  for (let i = 0; i < n; i++) {
    const a = (Math.PI * 2 * i) / n + Math.random() * 0.4;
    const sp = 40 + Math.random() * 180;
    out.push({
      x,
      y,
      vx: Math.cos(a) * sp,
      vy: Math.sin(a) * sp,
      life: 0.28 + Math.random() * 0.3,
      max: 0.5,
      size: 2 + Math.random() * 3,
      color,
    });
  }
  return out;
}

export function tickParticles(list: Particle[], dt: number): Particle[] {
  const next: Particle[] = [];
  for (const p of list) {
    p.life -= dt;
    if (p.life <= 0) continue;
    p.x += p.vx * dt;
    p.y += p.vy * dt;
    p.vy += 280 * dt;
    next.push(p);
  }
  return next;
}

export function drawParticles(ctx: CanvasRenderingContext2D, list: Particle[]): void {
  for (const p of list) {
    ctx.globalAlpha = Math.max(0, p.life / p.max);
    ctx.fillStyle = p.color;
    ctx.beginPath();
    ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.globalAlpha = 1;
}

export function pickupColor(id: PowerUpId): string {
  return POWER_COLOR[id];
}
